import { NgModule } from '@angular/core';
import { BdUserCookieModule } from '../user-consent/cookie';

@NgModule({
  imports: [BdUserCookieModule.forRoot()],
  exports: [],
  declarations: [],
})
export class BdUserCurrentUserModule {}
